<template>
  <vx-card no-shadow>
    <!-- Info -->
    <vs-input
      type="email"
      name="email"
      class="w-full"
      label-placeholder="Email"
      v-model="email"
    ></vs-input>
    <p style="font-size: 10px; margin: 5px" :class="darkTheme ? 'dark' : 'light'">
      Delivery Address
    </p>
    <vs-textarea
      class="w-full"
      v-model="deliveryAddress"
      rows="4"
    ></vs-textarea>
    <vs-input
      class="w-full"
      label-placeholder="Contact Name"
      v-model="deliveryName"
    ></vs-input>
    <vs-input
      class="w-full"
      label-placeholder="Phone number"
      v-model="deliveryPhone"
    ></vs-input>

    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end mt-3">
      <vs-button class="ml-auto mt-2" @click="saveDetails()"
        >Save changes</vs-button
      >
    </div>
  </vx-card>
</template>

<script>
export default {
  data() {
    return {
      // username: "",
      email: "",
      deliveryAddress: "",
      deliveryName: "",
      deliveryPhone: "",
      darkTheme: false,
    };
  },
  mounted() {
    this.getUserDetails();
  },
  methods: {
    saveDetails() {
      this.showLoadingSpinner();
      const urlWithParams = new URL(
        process.env.VUE_APP_BASE_URL + "Rest/saveCustomerSettings"
      );
      urlWithParams.searchParams.append("APIKey", process.env.VUE_APP_API_KEY);

      let newSettings = {
        email: this.email,
        delivery_address: this.deliveryAddress,
        contact_name: this.deliveryName,
        contact_phone: this.deliveryPhone,
      };
      fetch(urlWithParams.href, {
        method: "POST",
        mode: "cors",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newSettings),
      })
        .then((response) => response.json())
        .then((data) => {
          if (!this.encounteredErrors(data)) {
            this.alertUser("success", "User settings saved!");
          }
          this.hideLoadingSpinner();
        });
    },
  },
};
</script>

<style scoped>
.w-full {
  margin-bottom: 25px;
}

.w-full:first-child {
  margin-bottom: 0px;
}

.dark {
  color: #c2c6dc;
}

.light {
  color: rgba(0, 0, 0, 0.4);
}
</style>
